(()=>{
 function init(){
  const section=document.getElementById('product-reviews');
  if(!section||section.dataset.treviReviewActions)return;
  section.dataset.treviReviewActions='true';
  section.classList.add('trevi-mobile-reviews-preview');
  section.addEventListener('click',event=>{
   if(!window.matchMedia('(max-width:1023px)').matches)return;
   if(event.target.closest('.oke-showMore-button')&&section.classList.contains('trevi-mobile-reviews-preview')){
    const items=section.querySelectorAll('.oke-w-reviews-list-item');
    section.classList.remove('trevi-mobile-reviews-preview');
    if(items.length>3){event.preventDefault();event.stopImmediatePropagation();}
   }else if(event.target.closest('.trevi-review-filter-menu input, .oke-w-breakdownModule-distribution, .oke-w-navBar-item')){
    section.classList.add('trevi-mobile-reviews-preview');
   }
  },true);
  function sync(){
   const header=section.querySelector('.oke-w-header-content');
   const tabs=section.querySelectorAll('.oke-w-navBar-item');
   const write=section.querySelector('.oke-w-reviews-writeReview a, a.oke-w-reviews-writeReview');
   if(!header||tabs.length<2||!write)return;
   let actions=header.querySelector('.trevi-review-actions');
   if(!actions){
    actions=document.createElement('div');actions.className='trevi-review-actions';actions.setAttribute('aria-label','Review actions');
    ['Write a Review','Questions','Filter'].forEach((label,index)=>{
     const button=document.createElement('button');button.type='button';button.textContent=label;
     button.addEventListener('click',()=>{
      if(index===0){section.querySelector('.oke-w-reviews-writeReview a, a.oke-w-reviews-writeReview')?.click();return;}
      const currentTabs=section.querySelectorAll('.oke-w-navBar-item');
      if(index===1){currentTabs[currentTabs[1]?.getAttribute('aria-selected')==='true'?0:1]?.click();return;}
      currentTabs[0]?.click();
      const menu=actions.querySelector('.trevi-review-filter-menu');
      menu.hidden=!menu.hidden;button.setAttribute('aria-expanded',String(!menu.hidden));
      if(!menu.hidden){
       if(section.querySelector('#filter-toggle')?.getAttribute('aria-expanded')!=='true')section.querySelector('#filter-toggle')?.click();
       requestAnimationFrame(()=>{menu.querySelectorAll('input').forEach(input=>{input.checked=!!section.querySelector('#filter-options input[name="Rating '+input.value+'"]')?.checked;});menu.querySelector('input')?.focus();});
      }
     });actions.append(button);
    });
    const menu=document.createElement('div');menu.className='trevi-review-filter-menu';menu.id='trevi-review-filter-menu';menu.hidden=true;
    const title=document.createElement('strong');title.textContent='Filter by rating';menu.append(title);
    [5,4,3,2,1].forEach(rating=>{
     const label=document.createElement('label'),input=document.createElement('input'),text=document.createElement('span');
     input.type='checkbox';input.value=String(rating);text.textContent=rating+' '+(rating===1?'star':'stars');
     input.addEventListener('change',()=>{const original=section.querySelector('#filter-options input[name="Rating '+rating+'"]');if(original&&original.checked!==input.checked)original.click();});
     label.append(input,text);menu.append(label);
    });actions.append(menu);actions.children[2].setAttribute('aria-controls',menu.id);
    const close=()=>{menu.hidden=true;actions.children[2].setAttribute('aria-expanded','false');};
    document.addEventListener('click',event=>{if(!actions.contains(event.target))close();});
    actions.addEventListener('keydown',event=>{if(event.key==='Escape'){close();actions.children[2].focus();}});
    header.append(actions);section.classList.add('trevi-reviews-actions-ready');
   }
   const questionSelected=String(tabs[1].getAttribute('aria-selected')==='true');
   if(actions.children[1].getAttribute('aria-pressed')!==questionSelected)actions.children[1].setAttribute('aria-pressed',questionSelected);

  }
  sync();new MutationObserver(sync).observe(section,{childList:true,subtree:true,attributes:true,attributeFilter:['aria-selected','aria-expanded']});
 }
 init();document.addEventListener('shopify:section:load',init);
})();
